import React from 'react';
import { graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';

import { useGraphQL } from '../hooks';

import {
  Layout,
  SEO,
  Hero,
  CollectionGrid,
  JustLanded,
  JustDropped,
  NewsletterSignup,
  GoogleMap,
} from '../components';

function IndexPage({ data }) {
  return (
    <Layout>
      <SEO title="Home" />
      <div className="grid gap-6">
        <Hero />
        <CollectionGrid />
        <Products data={data} />
        <JustLanded />
        <JustDropped collection="capris" />
      </div>
      <NewsletterSignup />
      <GoogleMap />
    </Layout>
  );
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

function Products({ data }) {
  const { allJeans, allShoes } = data;
  return (
    <div className="grid py-6 gap-y-12">
      <ProductGrid
        products={allJeans.nodes}
        title="New Arrival Jeans"
        collection="jeans"
      />
      <ProductGrid
        products={allShoes.nodes}
        title="Hottest Shoes"
        collection="shoes"
      />
    </div>
  );
}

Products.propTypes = {
  data: PropTypes.object.isRequired,
};

function ProductGrid({ products, title, collection }) {
  const { placeholderImage } = useGraphQL();
  return (
    <div className="w-full max-w-xs px-4 mx-auto sm:max-w-2xl lg:max-w-7xl sm:px-6 lg:px-8">
      <div className="flex justify-between text-lg tracking-wider uppercase text-dark-pink">
        <h2>{title}</h2>
        <Link to={`/collections/${collection}/`} className="underline">
          View all
        </Link>
      </div>
      <div className="grid gap-4 mt-4 sm:grid-cols-2 lg:grid-cols-4">
        {products.map((product) => (
          <article key={product.id}>
            <Link to={`/products/${product.handle}/`}>
              <div className="relative h-0 aspect-ratio-square">
                <div className="absolute inset-0">
                  <img
                    src={
                      product.images[0]?.originalSrc ||
                      placeholderImage.publicURL
                    }
                    alt=""
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
              <div className="flex justify-between tracking-wider uppercase text-dark-pink">
                <div>{product.title}</div>
                <div>${product.priceRange.minVariantPrice.amount}</div>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
}

ProductGrid.propTypes = {
  collection: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export const query = graphql`
  {
    allJeans: allShopifyProduct(
      filter: { availableForSale: { eq: true }, productType: { eq: "Jeans" } }
      limit: 4
      sort: { fields: createdAt, order: DESC }
    ) {
      nodes {
        description
        handle
        id
        images {
          originalSrc
        }
        priceRange {
          minVariantPrice {
            amount
          }
        }
        productType
        title
      }
    }
    allShoes: allShopifyProduct(
      filter: { availableForSale: { eq: true }, productType: { eq: "Shoes" } }
      limit: 4
      sort: { fields: createdAt, order: DESC }
    ) {
      nodes {
        description
        handle
        id
        images {
          originalSrc
        }
        priceRange {
          minVariantPrice {
            amount
          }
        }
        productType
        title
      }
    }
  }
`;

export default IndexPage;
